<template>
  <div>
    <br />
    <samp class="d_time">{{ time[0] }}至{{ time[1] }}</samp>
    <span class="title">{{ title }}——{{ publicWord === 'item'?'项目':publicWord === 'product'?'产品':'套餐' }}详情</span>
    <br />
    <br />
    <customerTable :array="table_col" :data="pagedata" :is-show-input="true" :public-word="publicWord" :date-range="time" @timeChange="timeChange" @onDownload="onDownload" @onPrint="onPrint" />
    <el-pagination :current-page.sync="pageNum" background layout="prev, pager, next" :total="total" @current-change="handleCurrentChange"></el-pagination>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import api from '../../api/index.js';
import customerTable from '../others/customer_table.vue';

export default {
  components: {
    customerTable
  },
  data() {
    return {
      table_col: [],
      tableData: [],
      total: 0,
      time: [
        dayjs()
          .subtract(30, 'day')
          .format('YYYY-MM-DD'),
        dayjs().format('YYYY-MM-DD')
      ],
      id: null,
      pageNum: 1,
      title: '',
      publicWord: '',
      pageSize: 10,
      pagedata: [],
      value: '1'
    };
  },
  activated() {
    if (this.$route.params.date) {
      this.time = this.$route.params.date;
    } else {
      this.time = [
        dayjs()
          .subtract(30, 'day')
          .format('YYYY-MM-DD'),
        dayjs().format('YYYY-MM-DD')
      ];
    }
    this.pageNum = 1;
    if (this.$route.params.name) {
      localStorage.setItem('projectTitle', this.$route.params.name);
    }
    if (this.$route.params.timeCountType) {
      localStorage.setItem('timeCountType', this.$route.params.timeCountType);
    }
    this.title = this.$route.params.name || localStorage.getItem('projectTitle');
    this.value = this.$route.params.timeCountType || localStorage.getItem('timeCountType');
    const publicWord = this.$route.params.publicWord || localStorage.getItem('publicWord');

    if (publicWord) {
      localStorage.setItem('publicWord', publicWord);
    }
    this.publicWord = publicWord;
    if (publicWord === 'item') {
      this.$route.params.itemId
        ? localStorage.setItem('itemId', this.$route.params.itemId)
        : (this.id = localStorage.getItem('itemId'));

      this.onGetItemDetails();
    }
    if (publicWord === 'product') {
      this.$route.params.productId
        ? localStorage.setItem(
          'productId',
          this.$route.params.productId
        )
        : (this.id = localStorage.getItem('productId'));
      this.onGetProductDtails();
    }
    if (publicWord === 'vipCard') {
      this.$route.params.vipCardId
        ? localStorage.setItem(
          'vipCardId',
          this.$route.params.vipCardId
        )
        : (this.id = localStorage.getItem('vipCardId'));
      this.onGetVipCardDetails();
    }
  },
  methods: {
    // 获取 项目汇总详情页面
    onGetItemDetails() {
      const data = {
        beginTime: this.time[0],
        endTime: this.time[1],
        itemId: localStorage.getItem('itemId') || this.id,
        mainId: sessionStorage.getItem('mainId'),
        timeCountType: this.value
      };
      this.table_col = [
        {
          name: '开单时间',
          prop: 'payTime'
        },
        {
          name: '订单号',
          prop: 'orderCode'
        },
        {
          name: '顾客姓名',
          prop: 'customerName'
        },
        {
          name: '手机号',
          prop: 'phone'
        },
        {
          name: '出售数量',
          prop: 'countNum'
        },
        {
          name: '实收单价（元）',
          prop: 'price'
        },
        {
          name: '实收金额（元）',
          prop: 'realMoney'
        },
        {
          name: '支付方式',
          prop: 'payTypeList'
        },
        {
          name: '销售员工',
          prop: 'technicianNameList'
        },
        {
          name: '订单来源',
          prop: 'buySource'
        }
      ];
      api.getItemDetails(data).then((res) => {
        res.data = res.data ? res.data : [];
        res.data.forEach((a) => {
          if (a.technicianNameList) {
            if (a.technicianNameList.length == 0) {
              a.technicianNameList = '--';
            } else {
              let tval = '';
              a.technicianNameList.forEach((b, n) => {
                tval += b + (a.technicianNameList.length == (n + 1) ? '' : '，');
              });
              a.technicianNameList = tval;
            }
          } else {
            a.technicianNameList = '--';
          }
          if (!a.payType) {
            a.payType = '--';
          }
          if (!a.pheone) {
            a.pheone = '--';
          }
          if (a.payTypeList) {
            a.payTypeList = a.payTypeList.join('，');
          }
        });
        this.tableData = res.data;
        this.pageDataFn(1);
        this.total = res.data.length;
      });
    },
    // 获取 产品收入详情页面
    onGetProductDtails() {
      const data = {
        beginTime: this.time[0],
        endTime: this.time[1],
        productId: localStorage.getItem('productId') || this.id,
        mainId: sessionStorage.getItem('mainId'),
        pageNum: this.pageNum,
        pageSize: 10,
        timeCountType: this.value
      };
      this.table_col = [
        {
          name: '开单时间',
          prop: 'payTime'
        },
        {
          name: '订单号',
          prop: 'orderCode'
        },
        {
          name: '顾客姓名',
          prop: 'customerName'
        },
        {
          name: '手机号',
          prop: 'phone'
        },
        {
          name: '出售数量',
          prop: 'countNum'
        },
        {
          name: '实收单价（元）',
          prop: 'price'
        },
        {
          name: '实收合计（元）',
          prop: 'realMoney'
        },
        {
          name: '支付方式',
          prop: 'payType'
        },
        {
          name: '销售员工',
          prop: 'technicianNameList'
        },
        {
          name: '订单来源',
          prop: 'buySource'
        }
      ];
      api.getProductDtails(data).then((res) => {
        res.data.records = res.data.records ? res.data.records : [];
        res.data.records.forEach((a) => {
          if (a.technicianNameList) {
            if (a.technicianNameList.length == 0) {
              a.technicianNameList = '--';
            } else {
              let tval = '';
              a.technicianNameList.forEach((b, n) => {
                tval += b + (a.technicianNameList.length == (n + 1) ? '' : '，');
              });
              a.technicianNameList = tval;
            }
          } else {
            a.technicianNameList = '--';
          }
          if (!a.pheone) {
            a.pheone = '--';
          }
          if (!a.payType) {
            a.payType = '--';
          } else {
            a.payType = a.payType.join('，');
          }
        });
        this.total = res.data.total;
        this.pagedata = res.data.records;
      });
    },
    // 获取 套餐收入详情页面
    onGetVipCardDetails() {
      const data = {
        beginTime: this.time[0],
        endTime: this.time[1],
        vipCardId: localStorage.getItem('vipCardId') || this.id,
        mainId: sessionStorage.getItem('mainId'),
        pageNum: this.pageNum,
        pageSize: 10,
        timeCountType: this.value
      };
      this.table_col = [
        {
          name: '开单时间',
          prop: 'payTime'
        },
        {
          name: '订单号',
          prop: 'orderCode'
        },
        {
          name: '顾客姓名',
          prop: 'customerName'
        },
        {
          name: '手机号',
          prop: 'phone'
        },
        {
          name: '出售数量',
          prop: 'countNum'
        },
        {
          name: '实收单价（元）',
          prop: 'realPrice'
        },
        {
          name: '实收合计（元）',
          prop: 'realMoney'
        },
        {
          name: '支付方式',
          prop: 'payType'
        },
        {
          name: '销售员工',
          prop: 'technicianNameList'
        },
        {
          name: '订单来源',
          prop: 'buySource'
        }
      ];
      api.getVipCardDetails(data).then((res) => {
        res.data.records = res.data.records ? res.data.records : [];
        res.data.records.forEach((a) => {
          if (a.technicianNameList) {
            if (a.technicianNameList.length == 0) {
              a.technicianNameList = '--';
            } else {
              let tval = '';
              a.technicianNameList.forEach((b, n) => {
                tval += b + (a.technicianNameList.length == (n + 1) ? '' : '，');
              });
              a.technicianNameList = tval;
            }
          } else {
            a.technicianNameList = '--';
          }
          if (!a.payType) {
            a.payType = '--';
          }
          if (!a.phone) {
            a.phone = '--';
          }
        });
        this.total = res.data.total;
        this.pagedata = res.data.records;
      });
    },
    onDownload() {
      const publicWord = this.$route.params.publicWord || localStorage.getItem('publicWord');
      if (publicWord === 'item') {
        if (this.Lib.checkPower('beauty-5-dcxmxssrxq') == false) return;
        this.$root.$children[0].fatherExport('exportItemDetails', this.time[0], this.time[1], localStorage.getItem('itemId'), this.value);
      }
      if (publicWord === 'product') {
        if (this.Lib.checkPower('beauty-5-dccpxssrxq') == false) return;
        this.$root.$children[0].fatherExport('exportProductDetails', this.time[0], this.time[1], localStorage.getItem('productId'), this.value);
      }
      if (publicWord === 'vipCard') {
        if (this.Lib.checkPower('beauty-5-dctcxssrxq') == false) return;
        this.$root.$children[0].fatherExport('exportVipCardDetails', this.time[0], this.time[1], localStorage.getItem('vipCardId'), this.value);
      }
    },
    onPrint() {
      const publicWord = this.$route.params.publicWord || localStorage.getItem('publicWord');
      if (publicWord === 'item') {
        if (this.Lib.checkPower('beauty-5-dyxmxssrxq') == false) return;
        const data = {
          beginTime: this.time[0],
          endTime: this.time[1],
          itemId: localStorage.getItem('itemId') || this.id,
          mainId: sessionStorage.getItem('mainId'),
          pageSize: 9999999,
          timeCountType: this.value
        };
        api.getItemDetails(data).then((res) => {
          res.data ? '' : res.data = [];
          res.data.forEach((a) => {
            if (a.technicianNameList.length > 0) {
              let name = '';
              a.technicianNameList.forEach((b, n) => {
                name = name + b + (a.technicianNameList.length == (n + 1) ? '' : ',');
              });
              a.technicianNameList = name;
            } else {
              a.technicianNameList = '--';
            }
            if (a.payTypeList.length > 0) {
              let typeListName = '';
              a.payTypeList.forEach((b, n) => {
                typeListName = typeListName + b + (a.payTypeList.length == (n + 1) ? '' : ',');
              });
              a.payTypeList = typeListName;
            } else {
              a.payTypeList = '--';
            }
          });
          this.$print({
            data: res.data,
            table_tol: this.table_col,
            title: `${this.title}—项目详情`
          });
        });
      }
      if (publicWord === 'product') {
        if (this.Lib.checkPower('beauty-5-dycpxssrxq') == false) return;
        const data = {
          beginTime: this.time[0],
          endTime: this.time[1],
          productId: localStorage.getItem('productId') || this.id,
          mainId: sessionStorage.getItem('mainId'),
          pageNum: 1,
          pageSize: 9999999,
          timeCountType: this.value
        };
        api.getProductDtails(data).then((res) => {
          res.data.records ? '' : res.data.records = [];
          res.data.records.forEach((a) => {
            if (a.technicianNameList.length > 0) {
              let name = '';
              a.technicianNameList.forEach((b, n) => {
                name = name + b + (a.technicianNameList.length == (n + 1) ? '' : ',');
              });
              a.technicianNameList = name;
            } else {
              a.technicianNameList = '--';
            }
            if (a.payType.length > 0) {
              let typeListName = '';
              a.payType.forEach((b, n) => {
                typeListName = typeListName + b + (a.payType.length == (n + 1) ? '' : ',');
              });
              a.payType = typeListName;
            } else {
              a.payType = '--';
            }
          });
          this.$print({
            data: res.data.records,
            table_tol: this.table_col,
            title: `${this.title}—产品详情`
          });
        });
      }
      if (publicWord === 'vipCard') {
        if (this.Lib.checkPower('beauty-5-dytcxssrxq') == false) return;
        const data = {
          beginTime: this.time[0],
          endTime: this.time[1],
          itemId: localStorage.getItem('itemId') || this.id,
          mainId: sessionStorage.getItem('mainId'),
          vipCardId: localStorage.getItem('vipCardId') || this.id,
          pageNum: 1,
          pageSize: 9999999,
          timeCountType: this.value
        };
        api.getVipCardDetails(data).then((res) => {
          res.data.records ? '' : res.data.records = [];
          res.data.records.forEach((a) => {
            a.technicianNameList = a.technicianNameList || [];
            if (a.technicianNameList.length > 0) {
              let name = '';
              a.technicianNameList.forEach((b, n) => {
                name = name + b + (a.technicianNameList.length == (n + 1) ? '' : ',');
              });
              a.technicianNameList = name;
            } else {
              a.technicianNameList = '--';
            }
          });
          this.$print({
            data: res.data.records,
            table_tol: this.table_col,
            title: `${this.title}—套餐详情`
          });
        });
      }
    },
    // 分页数据处理函数
    pageDataFn(number) {
      // console.log(number)
      // 处于第几页 number
      // 保存每页数据的函数
      const pagedata = [];
      // pagesize=10 每页条数
      // 设置开始
      const start = 10 * number - 10;
      // 设置结束长度
      let end = 10 * number; // 长度判断 //所有分页数据 this.tableData
      end = end > this.tableData.length ? this.tableData.length : end;
      for (let i = start; i < end; i++) {
        // 所有分页数据 this.tableData
        pagedata.push(this.tableData[i]);
      }
      this.pagedata = pagedata;
      // console.log(this.pagedata);
    },
    timeChange(val) {
      this.time = val;
      const publicWord = this.$route.params.publicWord
                || localStorage.getItem('publicWord');

      if (publicWord === 'item') {
        this.onGetItemDetails();
      }
      if (publicWord === 'product') {
        this.onGetProductDtails();
      }
      if (publicWord === 'vipCard') {
        this.onGetVipCardDetails();
      }
    },
    handleCurrentChange() {
      const publicWord = this.$route.params.publicWord
                || localStorage.getItem('publicWord');

      if (publicWord === 'item') {
        this.pageDataFn(this.pageNum);
      }
      if (publicWord === 'product') {
        this.onGetProductDtails();
      }
      if (publicWord === 'vipCard') {
        this.onGetVipCardDetails();
      }
    }
  }
};
</script>

<style scope>
.title {
    color: #2d2f33;
    font-size: 16px;
    font-weight: bold;
}
.d_time {
  position: absolute;
  margin-top: 50px;
  color: #666;
}
</style>
